export default __webpack_public_path__ + "static/media/ok.f6ad544a.png";